export const SIZE = 'filterSize';
export const LID_COLOR = 'filterLidColor';
export const BASE_COLOR = 'filterBaseColor';
export const STREAM = 'filterStream';
export const QUANTITY = 'filterQuantity';

export const HOOD = 'filterHood';
export const APERTURE = 'filterAperture';
export const COLOR = 'filterColor';
export const PRINT = 'filterPrint';
export const DESIGN = 'filterDesign';
export const PANELS = 'filterPanels';
export const PACK = 'filterPack';
